/* Seguimiento de pedido: versión sin React del componente AqCstrackingTracking.
 * CADS 21-oct-2026 (analysis/2026-10-21_seguimiento-pedidos, scripts/shopify_tema_seguimiento.py):
 * - la hoja manda la empresa de envío en la columna "OLVA", no en "courier";
 * - la emisión de Olva sale del prefijo de la guía (26-02828213 -> 26): con la de la configuración (25) Olva no
 *   encontraba el envío o devolvía otro de 2025 con el mismo número;
 * - el envío de Olva solo vale si es de este pedido (doc_externo = CS-1180/1);
 * - Chazki y el resto muestran el estado de la hoja (columna "Seguimiento"), y Olva también si no responde;
 * - el número se normaliza (cs1180, #CS-1180, 1180 -> CS-1180);
 * - si la consulta falla lo dice, en vez de "No se encontraron resultados".
 */
(() => {
  if (customElements.get('order-tracking')) return;

  const OLVA_STATE_MAP = {
    REGISTRADO: 'Recibido por Olva',
    'RECIBIDO DEL CLIENTE': 'Recibido por Olva',
    'PRE DESPACHO': 'Recibido por Olva',
    DESPACHADO: 'Recibido por Olva',
    'RECEPCION DESPACHO': 'Recibido por Olva',
    ASIGNADO: 'En camino',
    ENTREGADO: 'Entregado',
    'CONFIRMACION EN TIENDA': 'Listo en Oficina Olva',
    MOTIVADO: 'Fallo de entrega'
  };

  // Estado que anota despacho en la hoja (columna "Seguimiento").
  const HOJA_STATE_MAP = {
    DESPACHADO: 'Despachado',
    'EN RUTA': 'En camino',
    ENTREGADO: 'Entregado'
  };

  const HEADERS = ['PEDIDO', 'EMPRESA DE ENVÍO', 'CÓDIGO DE SEGUIMIENTO', 'FECHA DE ENVÍO', 'ITEMS', 'ESTADO / LINK'];

  const TEXT_ERROR = 'No pudimos consultar tu pedido en este momento. Inténtalo de nuevo en unos minutos.';

  const el = (tag, attrs = {}, text) => {
    const node = document.createElement(tag);
    Object.entries(attrs).forEach(([k, v]) => node.setAttribute(k, v));
    if (text !== undefined && text !== null) node.textContent = text;
    return node;
  };

  const capitalizar = (s) => s.charAt(0) + s.slice(1).toLowerCase();

  // El pedido como lo guarda la hoja: CS-1180 (mayúsculas, sin "#" ni espacios, con guion; solo el número -> CS-).
  const normalizarPedido = (valor) => {
    const v = String(valor || '').trim().toUpperCase().replace(/^#/, '').replace(/\s+/g, '');
    const m = v.match(/^(?:CS-?)?(\d{1,6})$/);
    return m ? `CS-${m[1]}` : v;
  };

  // OLVA, CHAZKI, URBANO... La hoja la manda en la columna "OLVA"; "courier" queda por si la columna cambia de nombre.
  const empresaDe = (item) => String(item.courier || item.OLVA || '').trim().toUpperCase();

  const estadoHoja = (item) => {
    const raw = item.Seguimiento ? String(item.Seguimiento).trim().toUpperCase() : '';
    return raw ? HOJA_STATE_MAP[raw] || capitalizar(raw) : '';
  };

  // Guía de Olva "26-02828213": emisión 26 (el año) y remito 02828213.
  const partesOlva = (tracking) => {
    const m = tracking.match(/^(\d{2})-(\d+)$/);
    return m ? { emision: m[1], remito: m[2] } : { emision: '', remito: tracking.split('-')[1] || tracking };
  };

  class OrderTracking extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('.order-tracking__form');
      this.input = this.querySelector('.order-tracking__input');
      this.button = this.querySelector('.order-tracking__button');
      this.loading = this.querySelector('.order-tracking__loading');
      this.results = this.querySelector('.order-tracking__results');
      this.cfg = this.dataset;

      this.form.addEventListener('submit', (e) => {
        e.preventDefault();
        this.search();
      });

      // Permite enlazar directo: /pages/seguimiento?order=123
      const preset = new URLSearchParams(window.location.search).get('order');
      if (preset) {
        this.input.value = preset;
        this.search();
      }
    }

    async fetchJson(url) {
      const res = await fetch(url);
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      return res.json();
    }

    async search() {
      const order = normalizarPedido(this.input.value);
      this.input.value = order;
      this.results.innerHTML = '';
      if (!order) {
        this.renderEmpty();
        return;
      }

      this.setLoading(true);
      let data = null;
      let fallo = false;
      try {
        const main = await this.fetchJson(this.cfg.apiUrl + encodeURIComponent(order));
        if (Array.isArray(main)) data = main.sort((a, b) => new Date(b.date) - new Date(a.date));
        else fallo = true;
      } catch (err) {
        console.error('Error al buscar pedido:', err);
        fallo = true;
      }
      this.setLoading(false);

      if (data && data.length) this.renderTable(data);
      else if (fallo) this.renderMessage(this.cfg.textError || TEXT_ERROR);
      else this.renderEmpty();
    }

    setLoading(on) {
      this.loading.hidden = !on;
      this.button.disabled = on;
    }

    renderMessage(text) {
      this.results.innerHTML = '';
      this.results.appendChild(el('p', { class: 'order-tracking__empty' }, text));
    }

    renderEmpty() {
      this.renderMessage(this.cfg.textEmpty);
    }

    renderTable(data) {
      const table = el('table', { class: 'order-tracking__table' });
      const headRow = el('tr');
      HEADERS.forEach((h) => headRow.appendChild(el('th', { scope: 'col' }, h)));
      table.appendChild(el('thead')).appendChild(headRow);
      const tbody = table.appendChild(el('tbody'));

      data.forEach((item) => {
        const tr = el('tr');
        const cell = (label) => tr.appendChild(el('td', { 'data-label': label }));

        cell(HEADERS[0]).textContent = item.order ?? '-';
        cell(HEADERS[1]).textContent = empresaDe(item) || '-';

        const trackingCell = cell(HEADERS[2]);
        const tracking = item.tracking ? String(item.tracking).trim() : '';
        if (tracking) {
          const btn = el('button', { type: 'button', class: 'order-tracking__copy', title: 'Copiar' }, tracking);
          btn.addEventListener('click', () => this.copy(tracking, btn));
          trackingCell.appendChild(btn);
        } else {
          trackingCell.textContent = '-';
        }

        // La hoja guarda el día a medianoche de Lima: mostrarlo en hora de Lima para que no salga un día antes.
        cell(HEADERS[3]).textContent = item.date
          ? new Date(item.date).toLocaleDateString('es-PE', { timeZone: 'America/Lima' })
          : '-';
        cell(HEADERS[4]).textContent = item.items || '-';
        this.renderStatus(item, cell(HEADERS[5]));

        tbody.appendChild(tr);
      });

      this.results.innerHTML = '';
      this.results.appendChild(table);
    }

    renderStatus(item, td) {
      const empresa = empresaDe(item);
      const tracking = item.tracking ? String(item.tracking).trim() : '';
      const hoja = estadoHoja(item);

      if (empresa === 'OLVA' && tracking) {
        const { emision: prefijo, remito } = partesOlva(tracking);
        const emision = item.emision || prefijo || this.cfg.olvaEmision || '26';
        const clave = `${emision}-${remito}|${item.order}`;
        td.textContent = 'Consultando...';
        this.olvaCache = this.olvaCache || {};
        if (!this.olvaCache[clave]) this.olvaCache[clave] = this.fetchOlva(remito, emision, item.order);
        this.olvaCache[clave].then((s) => {
          td.textContent = s || hoja || 'En Proceso';
        });
        return;
      }

      let enlace = null;
      if (tracking && empresa === 'ENWAN') {
        enlace = `https://livetracking.simpliroute.com/widget/account/63764/tracking/${encodeURIComponent(tracking)}`;
      } else if (tracking && empresa === 'URBANO') {
        enlace = `https://www.urbanoexpress.com/tracking/?guides=${encodeURIComponent(tracking)}`;
      }
      if (enlace) {
        const caja = el('div');
        if (hoja) caja.appendChild(el('div', {}, hoja));
        caja.appendChild(el('a', { href: enlace, target: '_blank', rel: 'noopener noreferrer' }, this.cfg.textLink));
        td.appendChild(caja);
      } else if (hoja) {
        td.textContent = hoja;
      } else {
        td.textContent = tracking ? 'Consultar con Posventa' : 'En poder de Transportista';
      }
    }

    // Estado en vivo de Olva, o null si no responde o si el envío no es de este pedido (el mismo remito existe en
    // otros años y para otras empresas; doc_externo trae el registro de despacho, "CS-1180/1/2").
    async fetchOlva(remito, emision, order) {
      const url = `https://reports.olvaexpress.pe/webservice/rest/getTrackingInformation?tracking=${encodeURIComponent(remito)}&emision=${encodeURIComponent(emision)}&apikey=${encodeURIComponent(this.cfg.olvaKey || '')}&details=1`;
      try {
        const json = await this.fetchJson(url);
        const general = json && json.success && json.data ? json.data.general : null;
        if (!general) return null;
        const doc = String(general.doc_externo || '').replace(/\s+/g, '').toUpperCase();
        const pedido = String(order || '').toUpperCase();
        if (doc && pedido && doc !== pedido && !doc.startsWith(`${pedido}/`)) return null;
        const raw = general.nombre_estado_tracking ? String(general.nombre_estado_tracking).trim().toUpperCase() : '';
        return raw ? OLVA_STATE_MAP[raw] || capitalizar(raw) : null;
      } catch (err) {
        return null;
      }
    }

    copy(text, btn) {
      const done = () => {
        btn.dataset.copied = this.cfg.textCopied || 'Copiado';
        btn.classList.add('is-copied');
        clearTimeout(btn._t);
        btn._t = setTimeout(() => btn.classList.remove('is-copied'), 1600);
      };
      if (navigator.clipboard) navigator.clipboard.writeText(text).then(done, done);
      else done();
    }
  }

  customElements.define('order-tracking', OrderTracking);
})();
